import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { AppointmentTypeFilter } from 'screens/Book/Book.types';

export const useAppointmentTypeFilter = () => {
  const location = useLocation();

  const initialFilter = new URLSearchParams(location.search).get(
    'appointment_types'
  ) as AppointmentTypeFilter | null;
  const [selectedFilter, setSelectedFilter] = useState<AppointmentTypeFilter | null>(initialFilter);

  useEffect(() => {
    const param = new URLSearchParams(location.search).get('appointment_types');
    setSelectedFilter(param as AppointmentTypeFilter);
  }, [location.search]);

  return selectedFilter;
};
